import script from "./VisitCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./VisitCounter.vue?vue&type=script&setup=true&lang=js"

import "./VisitCounter.vue?vue&type=style&index=0&id=3e563235&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e563235"]])

export default __exports__